import toast from "react-hot-toast"

import DAO from "./dao"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PromiseMethodDescriptor = TypedPropertyDescriptor<(...args: never[]) => Promise<any>>
function ToastError<T extends DAO>(subject: string, action: string) {
  return (target: T, propertyKey: keyof T, descriptor: PromiseMethodDescriptor): PromiseMethodDescriptor => {
    const method = target[propertyKey]
    if (method instanceof Function === false) {
      throw new TypeError("ToastResult is only applied to methods")
    }

    return {
      ...descriptor,
      async value(this: DAO, ...args) {
        if (DAO.NO_TOASTS in this) return method.call(this, ...args)

        try {
          return await method.call(this.disableToasts(), ...args)
        } catch (error) {
          if (error instanceof Error === false) throw error
          if (import.meta.env.PROD === false) console.error("<DEVELOPMENT ONLY>", error)

          toast.error(`${subject} ${action.toLowerCase()} failed: ` + error.message, { duration: 10000 })
          throw error
        }
      },
    }
  }
}

export default ToastError
